module.exports = __webpack_public_path__ + "img/m-agr.eceb8a38.jpg";